export const IMAGE_EXTENSIONS = ['JPG', 'JPEG', 'PNG', 'GIF', 'HEIC', 'WEBP'];
export const IMAGE_EXTENSIONS_SVG = ['JPG', 'JPEG', 'PNG', 'GIF', 'SVG'];
export const VIDEO_EXTENSIONS = ['MP4', 'WMV', 'MOV', '3GP', 'FLV', 'WebM', 'AVI'];
export const AUDIO_EXTENSIONS = ['MP3', 'OGG', 'WAV', 'M4A', 'ACC', 'AAC', 'AMR'];
